import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SButton, SIcon } from '@strana-artw/ui-kit';
import defu from 'defu';
import { isUnset } from '@/shared/lib/utils/helpers';
export default {
  name: 'TheModal',
  components: {
    SButton: SButton,
    SIcon: SIcon,
    ActPage: function ActPage() {
      return import('@/features/documents/ui/ActPage');
    },
    ModalCheckUniqueness: function ModalCheckUniqueness() {
      return import('@/features/client-pinning/ui/ModalCheckUniqueness');
    },
    ModalTechSupport: function ModalTechSupport() {
      return import('@/features/support/ui/ModalTechSupport.vue');
    },
    ModalApartment: function ModalApartment() {
      return import('@/widgets/LotDetail/ui/modal/ModalApartment.vue');
    },
    ModalClientBindAgent: function ModalClientBindAgent() {
      return import('@/features/client-bind-agent/ui/ModalClientBindAgent.vue');
    },
    ModalContract: function ModalContract() {
      return import('@/features/contract/ui/ModalContract');
    },
    ModalEventAction: function ModalEventAction() {
      return import('@/features/calendar/ui/ModalEventAction');
    },
    ModalEventDetail: function ModalEventDetail() {
      return import('@/features/calendar/ui/ModalEventDetail');
    },
    ModalExtendDeal: function ModalExtendDeal() {
      return import('@/features/deals/ui/ModalExtendDeal');
    },
    ModalHint: function ModalHint() {
      return import('@/shared/ui/modals/ModalHint');
    },
    ModalMeetingAction: function ModalMeetingAction() {
      return import('@/features/meetings/ui/ModalMeetingAction');
    },
    ModalMeetingDetail: function ModalMeetingDetail() {
      return import('@/features/meetings/ui/ModalMeetingDetail');
    },
    ModalProfile: function ModalProfile() {
      return import('@/features/user-profile/ui/ModalProfile');
    },
    ModalRealtyBooking: function ModalRealtyBooking() {
      return import('@/features/booking/ui/ModalRealtyBooking');
    },
    ModalUploadDocuments: function ModalUploadDocuments() {
      return import('@/features/documents/ui/ModalUploadDocuments');
    },
    ModalFreeBookingForm: function ModalFreeBookingForm() {
      return import('@/features/booking/ui/free-booking/ModalFreeBookingForm');
    },
    ModalFreeBookingSkladForm: function ModalFreeBookingSkladForm() {
      return import('@/features/booking/ui/free-booking/ModalFreeBookingSkladForm');
    },
    ModalSuccess: function ModalSuccess() {
      return import('@/shared/ui/modals/ModalSuccess').then(function (module) {
        return module.ModalSuccess;
      });
    },
    ModalBooking: function ModalBooking() {
      return import('@/features/booking/ui/ModalBooking');
    },
    ModalClosedSalesRequest: function ModalClosedSalesRequest() {
      return import('@/features/closed-sales/ui/modal/ModalClosedSalesRequest.vue');
    },
    ModalDigitalCollection: function ModalDigitalCollection() {
      return import('@/entities/collection/ui/ModalDigitalCollection');
    },
    ModalCollectionComment: function ModalCollectionComment() {
      return import('@/entities/collection/ui/ModalCollectionComment');
    },
    ModalRequestCollection: function ModalRequestCollection() {
      return import('@/features/request-collection/ui/ModalRequestCollection.vue');
    },
    ModalRequestCallback: function ModalRequestCallback() {
      return import('@/features/request-callback/ui/ModalRequestCallback.vue');
    }
  },
  computed: {
    classes: function classes() {
      var _this$$style = this.$style,
        TheModal = _this$$style.TheModal,
        _hasOverlay = _this$$style._hasOverlay,
        _fullScreen = _this$$style._fullScreen;
      return [TheModal, this.$modal.data.overlay && _hasOverlay, this.$modal.data.fullScreen && _fullScreen];
    },
    data: function data() {
      return this.$modal.data;
    }
  },
  beforeMount: function beforeMount() {
    this.$modal.event.on('open', this.open);
    this.$modal.event.on('close', this.close);
    this.$modal.event.on('change', this.onChange);
    // document.addEventListener('keydown', this.closedByEscKey);
  },
  beforeDestroy: function beforeDestroy() {
    this.$modal.close();
    // document.removeEventListener('keydown', this.closedByEscKey);
    this.$modal.event.off('open', this.open);
    this.$modal.event.off('close', this.close);
    this.$modal.event.off('change', this.onChange);
  },
  methods: {
    leave: function leave() {
      //
    },
    enter: function enter() {
      //
    },
    open: function open(options) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var DEFAULTS, params, component, attrs, transition, overlay, floatingButton, duration, fullScreen, events, preventScroll, _iterator, _step, it, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.$modal.data.component) {
                _context.next = 1;
                break;
              }
              _context.next = 1;
              return _this.close();
            case 1:
              DEFAULTS = {
                attrs: null,
                component: null,
                transition: null,
                overlay: false,
                floatingButton: false,
                duration: 500,
                fullScreen: true,
                events: [],
                preventScroll: false
              };
              params = defu(options, DEFAULTS);
              component = params.component, attrs = params.attrs, transition = params.transition, overlay = params.overlay, floatingButton = params.floatingButton, duration = params.duration, fullScreen = params.fullScreen, events = params.events, preventScroll = params.preventScroll; // console.log('🚀 ~ file: TheModal.vue ~ line 146 ~ open ~ params', params);
              if (!isUnset(component)) {
                _context.next = 2;
                break;
              }
              console.warn('[TheModal open] component is required');
              return _context.abrupt("return");
            case 2:
              _this.$modal.change('component', component);
              _this.$modal.change('attrs', attrs);
              _this.$modal.change('transition', transition);
              _this.$modal.change('overlay', overlay);
              _this.$modal.change('floatingButton', floatingButton);
              _this.$modal.change('duration', duration);
              _this.$modal.change('fullScreen', fullScreen);
              _this.$modal.change('preventScroll', preventScroll);
              if (!events) {
                _context.next = 10;
                break;
              }
              _this.$modal.change('events', events);
              _iterator = _createForOfIteratorHelper(events);
              _context.prev = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context.next = 7;
                break;
              }
              it = _step.value;
              if (!(!it.value || !it.callback)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("continue", 6);
            case 5:
              _this.$on(it.value, it.callback); // Add event listeners
              console.log('🚀 ~ file: TheModal.vue ~ line 177 ~ open ~ it.value, it.callback', it.value, it.callback);
            case 6:
              _context.next = 4;
              break;
            case 7:
              _context.next = 9;
              break;
            case 8:
              _context.prev = 8;
              _t = _context["catch"](3);
              _iterator.e(_t);
            case 9:
              _context.prev = 9;
              _iterator.f();
              return _context.finish(9);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 8, 9, 10]]);
      }))();
    },
    close: function close() {
      // console.log('🚀 ~ file: TheModal.vue ~ line 215 ~ close ~ close');
      this.$modal.event.emit('modal:beforeClose');
      if (this.$modal.data.events) {
        var _iterator2 = _createForOfIteratorHelper(this.$modal.data.events),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var it = _step2.value;
            if (!it.value || !it.callback) {
              continue;
            }
            this.$off(it.value, it.callback);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      this.$modal.change('component', null);
      this.$modal.change('attrs', null);
      this.$modal.change('transition', null);
      this.$modal.change('overlay', null);
      this.$modal.change('floatingButton', false);
      this.$modal.change('duration', null);
      this.$modal.change('fullScreen', false);
    },
    onChange: function onChange(prop, val) {
      console.log('🚀 ~ file: TheModal.vue ~ line 245 ~ onChange ~ prop, val', prop, val);
      this.$set(this.$modal.data, prop, val);
    },
    handleCloseStart: function handleCloseStart() {
      this.$modal.event.emit('modal:beforeClose');
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$modal.event.emit('modal:closed');
    }
  }
};